module.exports = __webpack_public_path__ + "ui-static/img/logo-large_light.f8a77b88.svg";